import { Link } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs";
import { EmailLink, DirectEmailCard, PartnershipCard } from "../components/ContactInfo";

const COVERAGE = [
  "Software reviews",
  "Product comparisons",
  "Business software guides",
  "SaaS trends",
  "Productivity tools",
  "AI & automation",
];

export default function About() {
  return (
    <div className="max-w-5xl mx-auto px-5 lg:px-8 py-14" data-testid="about-page">
      <Breadcrumbs items={[{ label: "About" }]} />
      <header className="mb-14 max-w-3xl">
        <p className="eyebrow mb-3">About SaaSRadarHub</p>
        <h1 className="font-playfair text-4xl sm:text-5xl lg:text-6xl text-neutral-900 tracking-tight leading-[1.05] mb-6">
          We help people make better software decisions.
        </h1>
        <p className="text-lg text-neutral-700 leading-relaxed mb-5">
          SaaSRadarHub was created to make business software easier to understand.
        </p>
        <p className="text-base text-neutral-700 leading-relaxed mb-5">
          We research software platforms, compare their capabilities, explore
          real-world use cases, and publish practical guides designed to help
          businesses choose tools that fit their needs.
        </p>
        <p className="text-base text-neutral-700 leading-relaxed">
          Our focus is simple: explain software clearly, highlight where each
          product performs well, and help readers make informed decisions.
        </p>
      </header>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-10 py-12 border-y border-neutral-200">
        <div>
          <p className="eyebrow mb-4">What we cover</p>
          <ul className="space-y-3">
            {COVERAGE.map((c) => (
              <li key={c} className="flex items-start gap-3 text-neutral-800">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-indigo-800 shrink-0" />
                {c}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="eyebrow mb-4">Editorial philosophy</p>
          <p className="font-playfair text-3xl text-neutral-900 leading-tight">
            Useful first. <span className="italic text-indigo-800">Promotional second.</span>
          </p>
          <p className="mt-5 text-neutral-700 leading-relaxed">
            We don't pretend to have used every product personally. Where our
            assessments are based on research, we say so. Where they're based
            on direct testing, we say that too.
          </p>
        </div>
      </section>

      <section className="py-14 max-w-3xl">
        <h2 className="font-playfair text-3xl text-neutral-900 mb-5">How we fund this work</h2>
        <p className="text-neutral-700 leading-relaxed mb-4">
          Some articles on SaaSRadarHub contain affiliate links. If you purchase
          through one of these links, we may earn a small commission at no
          additional cost to you.
        </p>
        <p className="text-neutral-700 leading-relaxed">
          Affiliate relationships do not automatically determine editorial
          recommendations. We write about products based on what they do and
          who they serve well — not on which affiliate program pays best.
        </p>
      </section>

      <section className="py-14 border-t border-neutral-200" data-testid="about-contact">
        <p className="eyebrow mb-3">Contact</p>
        <h2 className="font-playfair text-3xl text-neutral-900 mb-5">Official business contact</h2>
        <p className="text-neutral-700 leading-relaxed mb-8 max-w-3xl">
          For reader questions, corrections, partnership and affiliate inquiries, email{" "}
          <EmailLink testid="about-email-link" />. You can also use our{" "}
          <Link to="/contact" className="text-indigo-800 underline underline-offset-4 decoration-indigo-200 hover:decoration-indigo-800">contact form</Link>.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <DirectEmailCard />
          <PartnershipCard />
        </div>
      </section>
    </div>
  );
}
